<template>
    <div>
        <a-card title="导入导出记录">
            <a-radio-group v-model="searchP.extype"  @change="handeleExtypeChange">
                <a-radio-button value="export">
                导出记录
                </a-radio-button>
                <a-radio-button value="import">
                导入记录
                </a-radio-button>
            </a-radio-group>
            <br />
            <br />
            <platformTab @platformcodeChange="handlePlatformChange"></platformTab>

            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="关键字">
                    <a-input v-model="searchP.keyword" style="width:400px"
                        :placeholder="keywordDesc"></a-input>
                </a-form-item>

                <!-- <a-form-item label="时间范围">
                    <timeRangeSelecter @handleTimeChange="handleTimeChange"></timeRangeSelecter>
                </a-form-item>    -->

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="list" :scroll="{ x: clientWidth}" :style="{width:tableWidth,marginTop:'20px'}"   :pagination="false" :loading="tLoading" rowKey="id" >
                <template slot="statues" slot-scope="text">
                    <span v-if="text == 0">未处理</span>
                    <span v-if="text == 1">处理成功</span>
                    <span v-if="text == 2">处理失败</span>
                </template>
                <template slot="importResult" slot-scope="text">
                    {{text}}
                    <!-- <span v-if="text == 1">全部成功</span>
                    <span v-if="text == 2">全部失败</span>
                    <span v-if="text == 3">部分成功</span> -->
                </template>

                <template slot="opration" slot-scope="record">
                    <a-icon style="color:#1890ff;" size="large" type="file-search" @click="handleDetail(record)" />
                </template>
            </a-table>

            <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
            <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
                 <json-viewer
                    :value="modalData"
                    :expand-depth=5
                    copyable
                    boxed
                    sort></json-viewer>
            </a-modal>

        </a-card>
    </div>
</template>

<script>
import JsonViewer from "vue-json-viewer"
import platformTab from "../com/platformtab.vue"
// import timeRangeSelecter from "@/components/TimeRangeSelecter"

let searchP= {
    platformcode:'',
    extype:'export',
    keyword:'',
    total:0,
    pageSize:10,
    page:undefined,
};
const colums_export = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'

    },
    {
        title: "详情",
        width:50,
        scopedSlots: { customRender: 'opration' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width:80,
        ellipsis: true

    },
    {
        title: '文件路径',
        dataIndex: 'exportfile',
        align: 'center',
        width:600,
        ellipsis: true

    },{
        title: '文件名',
        dataIndex: 'filename',
        align: 'center',
        width:280,
        ellipsis: true
    },{
        title: '导出描述',
        dataIndex: 'exportparamsdesc',
        align: 'center',
        width:100,
        ellipsis: true

    },{
        title: '导出数量',
        dataIndex: 'successcount',
        align: 'center',
        width:100,
        ellipsis: true,
    },{
        title: '导出状态',
        dataIndex: 'exportstatus',
        scopedSlots: { customRender: 'statues' },
        align: 'center',
        width:80,
        ellipsis: true,
    },
    {
        title: '业务类型',
        dataIndex: 'businesstype',
        align: 'center',
        width:180,
        ellipsis: true,
    },{
        title: '导出参数',
        dataIndex: 'exportparams',
        align: 'center',
        width:200,
        ellipsis: true
    },{
        title: '错误提示',
        dataIndex: 'errormsg',
        align: 'center',
        width:200,
        ellipsis: true,
    },{
        title: '错误详情',
        dataIndex: 'errormsgdesc',
        align: 'center',
        width:300,
        ellipsis: true,
    },{
        title: '时间',
        dataIndex: 'createtime',
        align: 'center',
        width:200,
        ellipsis: true,
    }
];

const colums_import_fp = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
        fixed: 'left'

    },
    {
        title: "详情",
        width:50,
        scopedSlots: { customRender: 'opration' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
        width:80,
        ellipsis: true
    },
    {
        title: '业务类型',
        dataIndex: 'businesstype',
        align: 'center',
        width:200,
        ellipsis: true,
    },{
        title: '导入源文件',
        dataIndex: 'sourcefile',
        align: 'center',
        width:400,
        ellipsis: true
    },{
        title: '异常文件',
        dataIndex: 'errorfile',
        align: 'center',
        width:300,
        ellipsis: true
    },{
        title: '导入状态',
        dataIndex: 'importstatus',
        scopedSlots: { customRender: 'statues' },
        align: 'center',
        width:80,
        ellipsis: true,
    },
    {
        title: '导入参数',
        dataIndex: 'importparams',
        align: 'center',
        width:100,
        ellipsis: true,
    },
    {
        title: '导入总数',
        dataIndex: 'datacount',
        align: 'center',
        width:100,
        ellipsis: true,
    },
    {
        title: '导入成功数',
        dataIndex: 'successcount',
        align: 'center',
        width:100,
        ellipsis: true,
    },
    {
        title: '导入失败数',
        dataIndex: 'errorcount',
        align: 'center',
        width:100,
        ellipsis: true,
    },
    {
        title: '导入结果',
        dataIndex: 'resultstatus',
        scopedSlots: {customRender:'importResult'},
        align: 'center',
        width:120,
        ellipsis: true,
    },
    {
        title: '成功信息',
        dataIndex: 'successresult',
        align: 'center',
        width:120,
        ellipsis: true,
    },
    {
        title: '错误信息',
        dataIndex: 'errormsg',
        align: 'center',
        width:200,
        ellipsis: true,
    },
    {
        title: '错误描述',
        dataIndex: 'errormsgdesc',
        align: 'center',
        width:300,
        ellipsis: true,
    },
    {
        title: '创建时间',
        dataIndex: 'createtime',
        align: 'center',
        width:200,
        ellipsis: true,
    },

 
    // {
    //     title: 'beanid',
    //     dataIndex: 'beanid',
    //     align: 'center',
    //     width:120,
    //     ellipsis: true,
    // },   
    // {
    //     title: '文件名',
    //     dataIndex: 'filename',
    //     align: 'center',
    //     width:120,
    //     ellipsis: true,
    // },     
];

export default {
    data() {

        return {
            form: this.$form.createForm(this),
            tLoading:false,
            searchP: searchP,
            list:[],
            clientWidth:800,
            tableWidth:'800px',
            modalVisible:false,
            modalData:{},
            columns:[],
            //关键字字段
            keywordDesc:'文件名/业务类型',
            //后端查下sqlid
            queryname:'',
            sTimeRange:'',
        };
    },
    methods: {
        handleTimeChange(v){
            this.sTimeRange = v;
        },
        handlePlatformChange(v){
            this.searchP.platformcode = v;
            this.searchP.keyword = '';
            this.searchP.page = 1;
            this.getData()
        },
        handleOk(){
            this.modalVisible = false;
        },
        handleDetail(record){
            this.modalData = record;
            this.modalVisible = true;
        },

        handeleExtypeChange(){
            this.getData()
        },

        getData(){
            let that = this;
            let requestType = '';
            if(this.searchP.extype == "export"){
                this.columns = colums_export;
                requestType = "filemanager/queryexportrecord"
            }
            else{
                this.columns = colums_import_fp;
                requestType="filemanager/queryimportrecord"
            }
            that.tLoading = true;
            that.$store
                .dispatch({
                    type: requestType,
                    params: {
                        platformcode:that.searchP.platformcode,
                        // starttime:that.sTimeRange.split('~')[0],
                        // endtime:that.sTimeRange.split('~')[1],
                    }
                })
                .then((res) => {
                    that.tLoading = false;
                    that.tLoading = false;
                    let result = res.data.data;
                    that.list = result.list;
                    that.searchP.total = result.totalRecords;
                });
        },
        //筛选提交
        handleSubmit(e) {
            e && e.preventDefault();
            this.getData()
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.getData()
        },
        //筛选重置
        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.keyword = '';
            this.getData();
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },

    components: {
        JsonViewer,
        platformTab,
        // timeRangeSelecter
    },
    mounted() {
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);
    },
};

</script>

<style lang="less" scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
